import { dataType } from "../../components/UniversalList/UniversalList";
import UniversalList from "../../components/UniversalList/UniversalList";
import { FiLogOut } from "react-icons/fi";
import Box from "@mui/material/Box";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { APIContext } from "../../store/APIStore";
import NotificationMessage, {
  notificationType,
} from "../../components/NotificationMessage/NotificationMessage";
import { v4 as uuidv4 } from "uuid";
import { StoreContext } from "../../store/Store";
import { InputAdornment, Typography } from "@mui/material";
import { BiSearch, BiX } from "react-icons/bi";
import FdButton from "../../components/UIComponents/Button/FdButton";
import FdTextField from "../../components/UIComponents/TextField/FdTextfield";
import { reservationView as classes } from "../ReservationsView/styles";
import {useRedirect } from "react-admin";
import { routePaths } from "../../baseLayout/SidebarMenu";
import IAttendee, { ICheckInAttendeeList } from "../../dataProvider/interfaces/IAttendee";
import SimpleActionDialog, {
  Props as DialogType,
} from "../../components/SimpleActionDialog/SimpleActionDialog";
import moment from "moment";
import { Loading } from "react-admin";

const CheckedInAttendee = ({setTotalItems}:{setTotalItems?:Function;}) => {
  const { eventId, sessionId } = useParams() as any;
  const api = useContext(APIContext);
  const [checkedInList, setCheckedInList] = useState<any>(null);
  const [loading, setLoading] = useState(true); // data loading flag
  const redirect = useRedirect();
  const [actionDialog, setActionDialog] = useState<DialogType>({
    open: false,
    title: "",
    content: <></>,
    maxWidth: false,
    fullWidth: false,
    isLoading: false,
    onConfirm: () => {},
    confirmLabel: "Save",
  });
  const notificationRef = useRef<any>();
  const [state] = useContext(StoreContext);
  const [searchKey, setSearchKey] = useState("");
  const searchRef = useRef<any>();

  const handleSearchClear = () => {
    setSearchKey("");
    fetchCheckedInAttendees();
  };
  const handleSearchKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      fetchCheckedInAttendees(searchKey);
    }
  };

  const fetchCheckedInAttendees = async (keyword?: string) => {
    try {
      setLoading(true);
      let selectedEventId = state.selectedEvent?.id || eventId;
      const fetchedAttendees = (await api.attendeeService.getCheckedInAttendees(
        selectedEventId,
        sessionId,
        keyword
      )) as unknown as ICheckInAttendeeList[];
      // const overLimit: ICheckInAttendeeList[] = fetchedAttendees.filter(
      //   (item: { accessAmount: number; consumedAmount: number }) =>
      //     item.accessAmount !== -1 && item.accessAmount < item.consumedAmount
      // );
      // const sortedCheckIn = new Set([...overLimit, ...fetchedAttendees]);
      // setCheckedInList(Array.from(sortedCheckIn));
      const list = Array.from(fetchedAttendees);
      if (setTotalItems) setTotalItems(list?.length || 0);
      setCheckedInList(list);
      setLoading(false);
    } catch (error) {}
  };
  useEffect(() => {
    fetchCheckedInAttendees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBulkDelete = async () => {
    try {
      //show loading dialog
      setActionDialog({
        ...actionDialog,
        open: true,
        title: "Processing data...",
        isLoading: true,
      });
      const data = {
        kioskInformation: {
          kioskId: "fdportal",
          kioskName: "fdportal",
          operator: state?.currentUser?.fullName, // username or email
          location: window.location.host, // fdportal
          osVersion: "osVersion", // os versi
          appVersion: "appVersion", // versions
        },
        eventSessionScans: checkedInList.map((item: { id: any }) => {
          return {
            attendee: {
              id: item.id,
            },
            scanAt: moment(new Date()).toISOString(),
            type: "SCAN_OUT",
            checkInMode: "Lookup",
            messageGUID: uuidv4(),
          };
        }),
      };
      // make request
      await api.attendeeService.checkoutAllAttendees(data, sessionId);

      // refresh the list
      fetchCheckedInAttendees();

      // hide dialog
      setActionDialog({
        ...actionDialog,
        open: false,
        isLoading: false,
      });

      //show notification message
      notificationRef.current?.show(
        "Attendees checked out",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        "Check out all failed",
        notificationType.Error
      );
      setActionDialog({
        ...actionDialog,
        open: false,
        isLoading: false,
      });
    }
  };

  const onSearchClick = (e: any) => {
    fetchCheckedInAttendees(searchKey);
  };

  // actions applied on all items
  const customActions = [
    {
      label: "Check out all",
      key: "checkOutAll",
      callback: handleBulkDelete,
      startIcon: <FiLogOut size="18" />,
    },
  ];
  return (
    <>
      <Box sx={classes.topFilters} display="flex" aria-label="topFilters">
        <FdTextField
          sx={classes.searchInput}
          placeholder="Search"
          type="text"
          inputRef={searchRef}
          name="search"
          onChange={(e) => {
            const keyword = e.target.value;
            setSearchKey(keyword);
          }}
          value={searchKey}
          autoFocus
          onKeyDown={handleSearchKeyDown}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <BiSearch size="18" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment
                position="end"
                sx={classes.clearIcon}
                onClick={handleSearchClear}
              >
                {searchKey.length > 0 && <BiX size="20" />}
              </InputAdornment>
            ),
          }}
        />
        <FdButton
          variant="contained"
          color="primary"
          onClick={onSearchClick}
          sx={classes.searchButton}
          ButtonName="Search"
        />
      </Box>
      <Box overflow="auto">
        {!loading ? <UniversalList
          className="CheckedInAttendees"
          list={checkedInList}
          setUpdate={() => {}}
          type={dataType.CHECKED_IN_ATTENDEE}
          customActions={customActions}
          onEdit={() => {}}
          onCheckOut={() => {
            console.log("check out function");
          }}
          onDelete={undefined}
          onItemClick={(item: IAttendee) => {
            redirect(
              `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.ATTENDEES}/${item}/${routePaths.EDIT}`
            );
          }}
          noDataContent={<Box sx={{p:2}}>No Data Found</Box>}
          /> : 
          <Box sx={classes.loadingStyle}> 
            <Loading />
          </Box>
          }
      </Box>
      <NotificationMessage ref={notificationRef} />

      {actionDialog.open && (
        <SimpleActionDialog
          onClose={() => {
            setActionDialog({ ...actionDialog, open: false });
          }}
          open={actionDialog.open}
          title={actionDialog.title}
          content={actionDialog.content}
          maxWidth={actionDialog.maxWidth as any}
          fullWidth={actionDialog.fullWidth}
          isLoading={actionDialog.isLoading}
          onConfirm={actionDialog.onConfirm}
          confirmLabel={actionDialog.confirmLabel}
        />
      )}
    </>
  );
};

export default CheckedInAttendee;
